import { useLang } from "../context/LanguageContext";

export default function LanguageSwitcher({ variant = "default", className = "" }) {
  const { lang, setLang, languages } = useLang();

  // variant: "default" (light bg for marketing pages) | "glass" (semi-transparent for overlays)
  const isGlass = variant === "glass";
  const containerCls = isGlass
    ? "glass rounded-full px-1.5 py-1 flex gap-0.5 shadow-sm"
    : "inline-flex items-center gap-0.5 bg-white border border-slate-200 rounded-full px-1.5 py-1 shadow-sm";

  return (
    <div className={`${containerCls} ${className}`} data-testid="lang-switcher">
      {languages.map((l) => {
        const active = lang === l.code;
        return (
          <button
            key={l.code}
            onClick={() => setLang(l.code)}
            aria-label={l.label}
            title={l.label}
            data-testid={`lang-${l.code}`}
            className={`text-xs px-2 py-1.5 rounded-full font-semibold transition-colors ${
              active
                ? "bg-[#0A2540] text-white"
                : isGlass ? "text-slate-700 hover:bg-white/60" : "text-slate-600 hover:bg-slate-100"
            }`}
          >
            <span className="mr-1" aria-hidden>{l.flag}</span>
            {l.code.toUpperCase()}
          </button>
        );
      })}
    </div>
  );
}
